export default {
  dbh_nav_show_new_version_default: '默认进入新版本',
  dbh_nav_back_to_old: '如需返回旧版，请先取消此默认勾选配置。',
  dbh_nav_mobile_title: '扫码前往DataBrain小程序',
  dbh_nav_chatgpt_tips: 'ChatGPT在这！我换位置啦～',
  dbh_agent_entry_fullscreen_mode: '全屏模式',
  dbh_agent_entry_copilot_mode: 'Copilot模式',
  dbh_nav_agent_tip_title: 'Agent：您的游戏数据智能AI专家。',
  dbh_nav_agent_tip_desc: 'DataBrain后续统一在Brainy站内提供Agent或模型。',
  dbh_nav_agent_tip_go_to_gpt: '点击前往 Brainy 使用GPT',
  dbh_nav_agent_tip_feedback: '点击反馈问题',
  dbh_agent_entry_already_on_agent_home: '当前已处于 Agent 首页',
};
